import React from 'react';
import { Modal } from '../../components/ui';
import ExportButton from '../../components/ExportButton';

// Phone version: one tap row per list (the set of functions a guest is invited
// to), then one file of the ticked ones - a sheet per list.
export default function FunctionSetsMobile({ vm, onClose }) {
  const { functionSets, setsOff, toggleSet, setsAllOn, toggleAllSets, chosenSets, setsReport,
    adder, adderIsMe, setAdderFilter } = vm;
  const guests = chosenSets.reduce((n, s) => n + s.guests, 0);

  return (
    <Modal
      fullScreen className="fnsets-modal" title="Guest lists by function" onClose={onClose}
      footer={<>
        <button className="btn light" style={{ flex: 1 }} onClick={onClose}>Close</button>
        <ExportButton report={setsReport} className="btn primary" label="⇪ Make the lists" />
      </>}
    >
      <div className="muted" style={{ fontSize: 12.5, marginBottom: 8 }}>
        A guest belongs to <strong>exactly one</strong> list: the whole set of functions they are
        invited to. Each list starts on its own page.
      </div>
      {adder && (
        <div className="fnsets-scope">
          Covering <strong>{adderIsMe ? 'your own guests' : adder.label}</strong>.
          <button type="button" className="linklike" onClick={() => setAdderFilter('')}>Everyone's</button>
        </div>
      )}
      <button type="button" className="btn light sm" style={{ marginBottom: 8 }} onClick={toggleAllSets}>
        {setsAllOn ? 'Untick all' : 'Tick all'}
      </button>
      {functionSets.length === 0 && <div className="card card-pad empty">No guests to list yet.</div>}
      {functionSets.map(s => {
        const on = !setsOff.has(s.key);
        return (
          <button key={s.key} type="button" className={'card card-pad fnsets-row' + (on ? ' on' : '')}
            onClick={() => toggleSet(s.key)}>
            <span className="fnsets-tick">{on ? '☑' : '☐'}</span>
            <span className="fnsets-main">
              <strong>{s.label}</strong>
              <span className="muted">{s.guests} guests · {s.persons} persons</span>
            </span>
          </button>
        );
      })}
      <div className="muted" style={{ fontSize: 12.5, marginTop: 8 }}>
        {chosenSets.length} {chosenSets.length === 1 ? 'list' : 'lists'} · {guests} guests
      </div>
    </Modal>
  );
}
